// Import necessary modules
import { useState } from "react";
import Head from "next/head";

const faqData = [
  {
    question: "What is NEET Support?",
    answer: (
      <p>
        NEET Support is a platform for NEET Aspirants to help them achieve their
        dreams by supporting them from preparation to counselling and beyond. We
        offer tools and services like Rank Predictor, College Predictor, Fees &
        Seat Matrix, Cut-off and Allotment, Pre-Exam analysis and much more.
      </p>
    ),
  },
  {
    question: "Can NEET Support help me find colleges?",
    answer: (
      <p>
        Yes, you can use our College Predictor and College Search Tools to find
        the best colleges, these tools are made with years of research,
        historical cut off trends and its advanced algorithms can forecast
        future trends, to find the best suitable college for you.
      </p>
    ),
  },
  {
    question: "How do I get started with NEET Support?",
    answer: (
      <p>
        Simply, fill in your details to signup and create an account and you can
        use these credentials to login to your dashboard where you can explore
        all the different services and tools available for you. Or, you can also
        call us at +91 956-046-5351 ,+91 991-098-9253 and we’ll personally guide you through the
        registration and portal access.
      </p>
    ),
  },
  {
    question: "How can I access and use the Rank Predictor Tool?",
    answer: (
      <p>
        Our Rank Predictor Tool is absolutely free to use, all you need to do is
        create a NEET Support Dashboard account so that you can input your Mock
        test scores or your NEET score if you’ve already appeared for NEET to
        obtain your predictor rank. The rank you obtain can be used later for
        finding the best colleges based on your rank.
      </p>
    ),
  },
  {
    question: "How does NEET Support help with counselling?",
    answer: (
      <p>
        NEET Support has developed India’s first 6-Step Counselling Portal which
        has simplified the whole counselling process and made the complex
        process a hassle free and easy process. All a candidate needs to do is
        follow the 6 simple steps on screen and he’ll be up and ready to be
        placed in the best college that he has always desired.
      </p>
    ),
  },
  {
    question: "What are the minimum marks for Counselling in NEET 2026?",
    answer: (
      <p>
        As per the official NEET UG 2026 results, the qualifying cut-off marks for different categories are as follows:
        <br />
        • General/EWS: 686 – 144 (50th percentile)
        <br />
        • OBC/SC/ST: 143 – 113  (50th percentile)
        <br />
        • UR/EWS-PwBD: 143 – 127  (50th percentile)
        <br />
        • OBC/SC/ST-PwBD: 126 – 113  (40th percentile)
        <br />
        These marks make you eligible for NEET counselling, but admission cut-offs vary significantly based on college, state quota, category, and round. Always refer to state and AIQ counseling authorities for the actual admission cut-offs.
      </p>
    ),
  },
  {
    question: "When will MCC NEET UG 2026 counselling start?",
    answer: (
      <p>
        MCC NEET UG 2026 counselling is expected to start in the first or third week of July 2026.
      </p>
    ),
  },
  {
    question: "What is the eligibility for NEET 2026?",
    answer: (
      <>
        <p>The eligibility criteria for appearing in NEET 2026 as prescribed by NTA are:</p>
        <ul
          className="text-sm"
          style={{ listStyleType: "disc", marginLeft: "20px" }}
        >
          <li>
            Age Requirement: Candidate must be at least 17 years old on or before
            December 31 of the admission year. There is no upper age limit for
            NEET UG.
          </li>
          <li>
            Educational Qualification: Candidate must have completed Class 12 (or
            equivalent) with Physics, Chemistry, Biology/Biotechnology, and
            English as core subjects.
          </li>
          <li>
            Minimum Marks Requirement in PCB (Physics, Chemistry, Biology/Biotechnology):
            <ul style={{ listStyleType: "circle", marginLeft: "20px" }}>
              <li>General Category: Minimum 50% aggregate marks</li>
              <li>SC/ST/OBC Categories: Minimum 40% aggregate marks</li>
              <li>PwD (General) Candidates: Minimum 45% aggregate marks</li>
            </ul>
          </li>
          <li>
            Number of Attempts: There is no limit on the number of attempts.
            Candidates can appear for NEET UG multiple times until they secure
            admission.
          </li>
        </ul>
      </>
    ),
  },

  {
    question: "What is the NEET 2026 counselling process?",
    answer: (
      <>
        <p>
          NEET counselling is a process where candidates are allotted MBBS, BDS,
          and other allied medical seats based on their NEET-UG score,
          reservation category, and college preferences. The counselling process
          generally includes the following stages:
        </p>
        <ul
          className="text-sm"
          style={{ listStyleType: "disc", marginLeft: "20px" }}
        >
          <li>
            Online Registration on the official MCC (for AIQ) or state websites.
          </li>
          <li>Choice Filling & Locking of preferred courses and colleges.</li>
          <li>
            Seat Allotment Result declaration based on merit and preferences.
          </li>
          <li>
            Reporting to the Allotted College for document verification and
            admission confirmation.
          </li>
        </ul>
        <p>
          Each stage must be completed within the specified timeline. Failing to
          report can result in seat cancellation.
        </p>
      </>
    ),
  },
  {
    question:
      "Who conducts the NEET counselling for All India Quota (AIQ) seats?",
    answer: (
      <>
        <p>
          The Medical Counselling Committee (MCC) under the Directorate General
          of Health Services (DGHS), Ministry of Health and Family Welfare,
          conducts the counselling for:
        </p>
        <ul
          className="text-sm"
          style={{ listStyleType: "disc", marginLeft: "20px" }}
        >
          <li>
            15% All India Quota (AIQ) seats in government medical/dental
            colleges (except in J&K).
          </li>
          <li>
            100% seats in Deemed Universities, Central Universities (like AMU,
            DU, BHU), and ESIC colleges.
          </li>
          <li>
            AIIMS and JIPMER admissions are also included under MCC from 2020
            onwards.
          </li>
        </ul>
      </>
    ),
  },
  {
    question: "How many rounds should be there in NEET 2026 counselling?",
    answer: (
      <>
        <p>There are four rounds in NEET UG Counselling conducted by MCC:</p>
        <ul
          className="text-sm"
          style={{ listStyleType: "disc", marginLeft: "20px" }}
        >
          <li>Round 1</li>
          <li>Round 2</li>
          <li>Mop-Up Round</li>
          <li>Stray Vacancy Round</li>
          <li>Special Stray Vacancy Round</li>
        </ul>
        <p>
          State counselling authorities may also follow a similar format. If any
          seats remain vacant after these rounds, they may be handed over to the
          respective colleges for final round admissions (in private/deemed
          institutes).
        </p>
      </>
    ),
  },
  {
    question: "What documents do I need for NEET counselling?",
    answer: (
      <>
        <p>
          Here is a list of essential documents required during NEET counselling
          and college reporting:
        </p>
        <ul
          className="text-sm"
          style={{ listStyleType: "disc", marginLeft: "20px" }}
        >
          <li>NEET 2026 Admit Card</li>
          <li>NEET Scorecard</li>
          <li>Class 10 & 12 Marksheets and Passing Certificates</li>
          <li>Birth Certificate (if required)</li>
          <li>Government-issued Photo ID (Aadhar, PAN, Passport, etc.)</li>
          <li>Category Certificate (SC/ST/OBC/EWS), if applicable</li>
          <li>PwD Certificate (if applicable)</li>
          <li>Provisional Allotment Letter (download from MCC portal)</li>
          <li>Passport-sized photographs (same as used in NEET application)</li>
          <li>
            Domicile/State Residence Certificate (for state quota counselling)
          </li>
          <li>Character Certificate</li>
          <li>Transfer Certificate</li>
          <li>Medical Fitness Certificate</li>
        </ul>
      </>
    ),
  },

  {
    question: "Is there any reservation in NEET counselling?",
    answer: (
      <>
        <p>
          Yes. NEET counselling follows the Government of India’s reservation
          policy:
        </p>
        <ul
          className="text-sm"
          style={{ listStyleType: "disc", marginLeft: "20px" }}
        >
          <li>SC: 15%</li>
          <li>ST: 7.5%</li>
          <li>OBC-NCL: 27%</li>
          <li>EWS: 10%</li>
          <li>PwD: 5% (horizontal reservation across all categories)</li>
        </ul>
        <p className="italic">
          Note: States may have their own reservation criteria under state quota
          counselling.
        </p>
      </>
    ),
  },
  {
    question: "How many medical colleges are participating in NEET UG 2026?",
    answer: (
      <p>
        As per the latest data, <strong>824</strong> medical colleges across India are expected
        to participate in NEET UG 2026 admissions. These include government,
        private, and deemed universities offering MBBS programs.
      </p>
    ),
  },
  {
    question: "How many MBBS seats are available for NEET UG 2026 aspirants?",
    answer: (
      <>
        <p>
          As per the latest update from the National Medical Commission (NMC), a
          total of <strong>1,29,805 MBBS</strong> seats are available for NEET UG 2026 aspirants
          across India. These seats are offered by both government and private
          medical colleges and are distributed under different quotas such as
          All India Quota (AIQ), State Quota, Management Quota, and NRI Quota.
        </p>

        <p className="italic">
          <strong>Note:</strong> According to the NMC's last official notice for
          the academic year 2025-26, the total number of approved MBBS seats was
          <strong> 1,18,148.</strong> The revised UG seat matrix as of <strong>31-03-2025</strong> for the <strong>2025-26 </strong>
          session reflects an updated total of <strong>1,29,805 MBBS</strong>  seats, including
          new medical colleges and additional seat approvals
        </p>
      </>
    ),
  },
{
  question: "How many applicants appeared for NEET UG 2025?",
  answer: (
    <p>
      For NEET UG 2025, a total of <strong>22,76,069</strong> candidates registered.
      Out of them, <strong>22,09,318</strong> candidates appeared for the exam while
      <strong>66,751</strong> candidates were absent. Among those who appeared,
      <strong>12,36,531</strong> candidates qualified. With such high participation,
      competition remains intense for securing admission in top medical colleges.
    </p>
  ),
}
];

const FAQ = () => {
  const [activeFAQ, setActiveFAQ] = useState(null);

  const toggleFAQ = (index) => {
    setActiveFAQ(activeFAQ === index ? null : index);
  };

  return (
    <>
      {/* <Head>
        <title>{metadata.title}</title>
        <meta name="description" content={metadata.description} />
        <meta name="keywords" content={metadata.keywords} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta charSet="utf-8" />
        <link rel="canonical" href={metadata.canonical} />
        <meta name="robots" content={metadata.robots} />
      </Head> */}

      <section className="w-full max-w-7xl mx-auto mt-14 mb-16 sm:mb-0">
        <h2
          className="sm:text-3xl text-2xl font-bold text-center capitalize"
          style={{ color: "#140342", fontSize: "28.125px" }}
        >
          Frequently asked <span className="text-[#ff9245]">questions</span>
        </h2>
        <div className="mt-8 space-y-4 ml-6 mr-6">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className={`p-4 border rounded-lg shadow-md ${activeFAQ === index ? "bg-gray-50" : ""
                }`}
              onClick={() => toggleFAQ(index)}
            >
              <div className="flex justify-between items-center cursor-pointer">
                <h3
                  className="text-lg font-semibold"
                  style={{ color: "#140342", fontSize: "16.875px" }}
                >
                  {faq.question}
                </h3>
                <span>{activeFAQ === index ? "-" : "+"}</span>
              </div>
              <div
                className={`mt-2 text-gray-600 text-left text-lg ${activeFAQ === index ? "block" : "hidden"
                  }`}
              >
                {faq.answer}
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default FAQ;

// Notes:
// 1. Replaced `react-helmet` with `next/head` for SEO and metadata management, as it's the standard for Next.js.
// 2. Ensure that Tailwind CSS is properly configured in your Next.js project to use the specified classes.
// 3. Place this file in the `pages` directory (e.g., `pages/faq.js`) so that it can be accessed at `/faq`.
